import { Menu, MenuItem } from 'components/common';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { IFullMenuProps } from './types';

export const FullMenu: FC<IFullMenuProps> = ({ anchorElement, onMenuClose, menuOptions }) => {
  return (
    <>
      <Menu
        sx={{ mt: '45px' }}
        id='menu-appbar-user'
        anchorEl={anchorElement}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        keepMounted
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={Boolean(anchorElement)}
        onClose={onMenuClose}
      >
        {menuOptions.map(({ textId, onClick }) => (
          <MenuItem key={textId} onClick={onClick}>
            <span className={'text-center'}>
              <FormattedMessage id={textId} />
            </span>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
